import Interval from './Interval';
export default Interval;